import { createFileRoute, useMatch } from '@tanstack/react-router';
import { FamilyDetail } from './-components/FamilyDetail';
import { prefetchFamilyLedgerDetail } from './-query';
export const Route = createFileRoute('/_staff/person/$id/_profile/family/$familyPersonId/')({
  component: RouteComponent,
  loader: ({
    params
  }) => prefetchFamilyLedgerDetail(params.id, params.familyPersonId)
});
function RouteComponent() {
  const {
    id: personId,
    familyPersonId
  } = useMatch({
    from: '/_staff/person/$id/_profile/family/$familyPersonId/',
    select: m => m.params
  });
  return <FamilyDetail personId={personId} familyPersonId={familyPersonId} linkTo="/person/$id/family/$familyPersonId" />;
}